
const common = {
  loading: 'Loading...',
  save: 'Save',
  cancel: 'Cancel',
  delete: 'Delete',
  edit: 'Edit',
  close: 'Close',
  confirm: 'Confirm',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  search: 'Search',
  filter: 'Filter',
  sort: 'Sort',
  export: 'Export',
  import: 'Import',
  print: 'Print',
  download: 'Download',
  upload: 'Upload',
  submit: 'Submit',
  reset: 'Reset',
  clear: 'Clear',
  select: 'Select',
  selectAll: 'Select All',
  deselectAll: 'Deselect All',
  yes: 'Yes',
  no: 'No',
  ok: 'OK',
  error: 'Error',
  success: 'Success',
  warning: 'Warning',
  info: 'Info',
  required: 'Required',
  optional: 'Optional',
  theme: {
    light: 'Light Theme',
    dark: 'Dark Theme',
    toggle: 'Toggle Theme'
  },
  language: {
    turkish: 'Türkçe',
    english: 'English',
    change: 'Change Language'
  },
  home: {
    title: 'Occupational Health and Safety Management System',
    subtitle: 'Protect employee health, increase workplace safety',
    cta: 'Get Started',
    hero: {
      title: 'Occupational Health and Safety Management System',
      subtitle: 'Protect employee health, increase workplace safety and minimize risks in your workplace. Prepare your business for the future with comprehensive health monitoring and safety management.',
      login: 'Login',
      register: 'Register'
    },
    features: {
      title: 'Key Features',
      subtitle: 'Digitize your occupational health and safety processes and protect your employees\' health'
    }
  },
  features: {
    health: {
      title: 'Health Monitoring',
      desc: 'Track employee health status, manage periodic examinations'
    },
    safety: {
      title: 'Safety Management',
      desc: 'Implement workplace safety protocols, minimize risks'
    },
    hygiene: {
      title: 'Hygiene Control',
      desc: 'Maintain and monitor workplace hygiene standards'
    },
    analysis: {
      title: 'Risk Analysis',
      desc: 'Conduct detailed risk analyses, take preventive measures'
    },
    warning: {
      title: 'Early Warning',
      desc: 'Detect potential hazards in advance and receive alerts'
    },
    reporting: {
      title: 'Reporting',
      desc: 'Generate comprehensive reports, meet legal requirements'
    }
  },
  footer: {
    company: 'We provide leading technology solutions in occupational health and safety.',
    rights: 'All rights reserved.'
  },
  auth: {
    login: {
      title: 'Login',
      subtitle: 'Sign in to your account',
      email: 'Email',
      password: 'Password',
      submit: 'Sign In',
      forgot: 'Forgot Password',
      register: 'Don\'t have an account? Sign up'
    },
    register: {
      title: 'Register',
      subtitle: 'Create a new account',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      submit: 'Sign Up',
      login: 'Already have an account? Sign in'
    },
    logout: 'Logout'
  },
  dashboard: {
    title: 'Dashboard',
    welcome: 'Welcome',
    overview: 'Overview',
    users: 'Users',
    reports: 'Reports',
    incidents: 'Incidents',
    settings: 'Settings',
    stats: {
      totalUsers: 'Total Users',
      totalReports: 'Total Reports',
      pendingApprovals: 'Pending Approvals',
      activeIncidents: 'Active Incidents'
    },
    recentActivities: 'Recent Activities',
    systemStatus: 'System Status'
  }
};

export default common;
